import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../../common_components/StaticFooter";
import StaticHeader from "../../common_components/staticHeader";
import $ from 'jquery'

class JuryDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            juryDetailsPdf: ''
        };
    }

    componentDidMount() {
        this.loadscript()
        this.setState({ juryDetailsPdf: this.props.location.state != null && this.props.location.state.juryDetailsPdf })
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }
    render() {
        const { juryDetailsPdf} = this.state;
        return (
            <>
                <StaticHeader />
                <>
                    <div className="website">
                        <iframe
                            id="myIframe"
                            // src={`/${sessionStorage.getItem("sessionExhibitionID")}/Rules-and-Regulations.pdf#toolbar=0&navpanes=0`}
                            src={`${juryDetailsPdf}#toolbar=0&navpanes=0`}
                            // src={`${juryDetailsPdf}`}
                            style={{marginTop:'125px'}}
                            width="100%"
                            height="800px"
                            title="Bing"
                        >
                            &lt;/div&gt; &lt;div style="height: 100px;"&gt;&lt;/div&gt;
                            &lt;/div&gt; &lt;/div&gt; &lt;/div&gt;
                        </iframe>
                    </div>
                </>

                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(JuryDetails)
);
